import React from "react"
import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import { Link } from "react-router-dom"
import { SortIcon } from "components/Table_SortColumnIcon"
import { getFormattedTime } from "utils"

const peopleListColumn = (customActions) => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, user) => <>{user.id}</>,
    },
    {
      dataField: "profile_pic",
      text: "#",
      formatter: (cellContent, user) => (
        <>
          {!user.profile_pic ? (
            <div className="avatar-xs">
              <span className="avatar-title rounded-circle">
                {user.first_name && user.first_name.charAt(0)}
              </span>
            </div>
          ) : (
            <div>
              <img
                className="rounded-circle avatar-xs"
                src={user.profile_pic.file.url}
                alt=""
              />
            </div>
          )}
        </>
      ),
    },
    {
      text: "Name",
      dataField: "full_name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1 text-decoration-underline">
            <Link to={`/profile/${user.id}`} className="text-primary">
              {user.full_name}
            </Link>
          </h5>
          {/*<p className="text-muted mb-0">{user.designation}</p>*/}
        </>
      ),
    },
    {
      text: "E-mail",
      dataField: "email",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      // formatter: (cellContent, user) => (
      //   <>
      //     <h5 className="font-size-14 mb-1">
      //       <Link to="#" className="text-dark">
      //         {user.display_name}
      //       </Link>
      //     </h5>
      //     {/*<p className="text-muted mb-0">{user.designation}</p>*/}
      //   </>
      // )
    },
    {
      dataField: "role",
      text: "Roles",
      formatter: (cellContent, user) => (
        <>
          {user.roles.map((role, key) => (
            <div key={key}>{role.name}</div>
          ))}
        </>
      ),
    },
    {
      dataField: "business_units",
      text: "Business units",
      formatter: (cellContent, user) => (
        <>
          {user?.business_units?.length > 0 &&
            user.business_units.map((bu, key) => (
              <div key={key}>{bu.name}</div>
            ))}
        </>
      ),
    },
    {
      text: "Tags",
      dataField: "tags",
      formatter: (cellContent, user) => (
        <>
          {user.tags.map((tag, key) => (
            <div key={key}>
              <Badge
                className={"font-size-10 badge-soft-" + "primary"}
                color={"primary"}
                pill
              >
                {tag?.tag}{" "}
              </Badge>
            </div>
          ))}
        </>
      ),
    },
    {
      dataField: "blocked",
      text: "Status",
      formatter: (cellContent, user) => (
        <>
          {user.blocked === 0 && <div>Active</div>}
          {user.blocked === 1 && <div>Inactive</div>}
          {user.blocked > 1 && <div>Pending</div>}
        </>
      ),
    },
    {
      text: "Last access",
      dataField: "last_access",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      // align: "right",
      // headerAlign: "right",
      formatter: (cellContent, user) => {
        return (
          <div className={"font-size-12"}>
            {getFormattedTime(user.last_access)}
          </div>
        )
      },
    },
    {
      text: "Member since",
      dataField: "registered_at",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      // align: "right",
      // headerAlign: "right",
      formatter: (cellContent, user) => {
        return (
          <div className={"font-size-12"}>
            {getFormattedTime(user.registered_at)}
          </div>
        )
      },
    },
    {
      dataField: "menu",
      isDummyField: true,
      align: "right",
      headerAlign: (column, colIndex) => "right",
      hidden: customActions && customActions?.length === 0,
      formatter: (cellContent, user) => (
        <UncontrolledDropdown>
          <DropdownToggle href="#" className="card-drop" tag="i">
            <i className="mdi mdi-dots-vertical font-size-18" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            {customActions?.map((a, index) => {
              let actionName = a.name
              let actionIcon = a.icon
              if (a?.checkBlockStatus) {
                if (user?.blocked === 1) {
                  actionName = "Revert inactive user"
                  actionIcon = "bx bx-check-circle"
                }
              }
              return (
                <DropdownItem
                  key={index}
                  href="#"
                  onClick={e => {
                    e.preventDefault()
                    a.onClick(user)
                  }}
                  disabled={a?.isAvailable === false}
                >
                  <i className={actionIcon} /> {actionName}
                </DropdownItem>
              )
            })}
          </DropdownMenu>
        </UncontrolledDropdown>
      ),
    },
  ]
}

export default peopleListColumn
